import { render } from "./XIconSolidLifeBuoy.vue?vue&type=template&id=170646a8"
import script from "./XIconSolidLifeBuoy.vue?vue&type=script&lang=js"
export * from "./XIconSolidLifeBuoy.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidLifeBuoy.vue"]])

export default __exports__